export const CASESTUDY_FIELDS = [
  "id",
  "status",
  "name",
  "project",
  "project_name_alias",
  "date_started",
  "tag_line",
  "client_requirement",
  "solution_overview",
  "obstacles",
  "achievements",
  "team_size",
  "duration",
  "screenshots",
  "testimonials.id",
  "testimonials.feedback",
  "tools.tool.id",
  "tools.tool.name",
  "tools.tool.type",
  "tech_stack.tech_stack.id",
  "tech_stack.tech_stack.name",
  "tech_stack.tech_stack.type",
  "outcomes.id",
  "outcomes.description",
  "outcomes.type",
  "deliverables.id",
  "deliverables.name",
  "deliverables.url",
  "methodology",
  "video",
  "nda_level",
  "industry",
  "industry_v1.name",
  "industry_v1.id",
  "industry_v1.type",
  
];
